/**
 * Automatically size account items to the width of the largest item.
 */

const SELECTORS = {
  root: ".btn-group--horizontal",
  item: ".account-group, .btn-group__form"
};

const instance = ($el: HTMLElement) => {
  const items = $el.querySelectorAll(SELECTORS.item);
  let maxWidth = 0;

  items.forEach(($item: Element) => {
    const $htmlElement = $item as HTMLElement;
    const itemWidth = $htmlElement.offsetWidth;
    if (itemWidth > maxWidth) {
      maxWidth = itemWidth;
    }
  });

  items.forEach(($item: Element) => {
    const $htmlElement = $item as HTMLElement;
    $htmlElement.style.width = `${maxWidth}px`;
  });
};

export default () => {
  document.querySelectorAll(SELECTORS.root).forEach(($el: Element) => {
    instance($el as HTMLElement);
  });
};
